import React from "react";
import {ScaleLoader} from 'react-spinners';

class Loader extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (<div className='sweet-loading' style={{marginTop: '20%', textAlign: 'center', position: 'relative'}}>
            <ScaleLoader
                color={'#14959f'}
            />
        </div>)
    }


}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/index.jsx